import React from 'react';
import PropTypes from 'prop-types';
// import Script from 'next/script'; // added in Next 11

const hjSettings = {
    hjid: 1666135,
    hjsv: 6,
};

const hotjarSetup = `window.hj=window.hj||function(){window.hj.q=(window.hj.q||[]).push(arguments);}
window._hjSettings=${JSON.stringify(hjSettings)};`;

export const hotjar = (enabled) =>
    enabled ? (
        <>
            <script dangerouslySetInnerHTML={{ __html: hotjarSetup }} />
            <script async={true} src={`https://static.hotjar.com/c/hotjar-${hjSettings.hjid}.js?sv=${hjSettings.hjsv}`} />
        </>
    ) : null;

export const Hotjar = ({ enabled }) => <>{hotjar(enabled)}</>;

Hotjar.propTypes = {
    enabled: PropTypes.bool,
};
